import { request, type PanelEntry } from "./api";

export interface SurfacePage extends PanelEntry {
  surface_blocks: number[];
  origin: "local" | "shipped" | "unknown";
  editable: boolean;
  edit_mode?: "local" | "instantiate" | "unavailable";
}
/** A page request the console saved, so it survives this tab (D402). */
export interface SavedSurfaceRequest {
  command_id: string;
  obligation_id: string | null;
  session_id: string | null;
  panel_key: string | null;
  text: string;
  requested_at: number | null;
  state: "draft" | "submitted";
  action_state: string | null;
}
export interface SurfacePages {
  pages: SurfacePage[];
  /** Optional so a reader that only wants the page list stays a reader of it. */
  requests?: SavedSurfaceRequest[];
  authoring: {
    available: boolean;
    detail: string;
    missing_tools: string[];
    skill_registered: boolean;
  };
}
export interface SurfaceRequest {
  text: string;
  session_id: string;
  command_id: string;
  panel_key?: string;
}
export interface SurfaceReceipt {
  command_id: string;
  obligation_id: string;
  session_id: string;
}
export const surfaceRequests = {
  pages: () => request<SurfacePages>("/api/surface-pages"),
  submit: (body: SurfaceRequest) =>
    request<SurfaceReceipt>("/api/surface-requests", {
      method: "POST",
      body: JSON.stringify(body),
    }),
};
